<!-- DESKTOP MENU -->
<div class="d-none d-md-flex align-items-center">
  <ul class="header-menu nav nav-pills justify-content-end flex-column flex-sm-row align-items-center">

    <!-- HOME -->
    <li class="home nav-item">
      <small [hidden]="organization || !errorReadingOrganization">
        <span class="nav-link" [ngClass]="{'active': activeTab === 'HOME'}">
          <fa-icon *ngIf="!errorReadingOrganization" [icon]="faSpinner" animation="spin"></fa-icon>
          <fa-icon *ngIf="errorReadingOrganization" [icon]="faExclamationTriangle" ngbPopover="{{errorReadingOrganization}}" triggers="mouseenter:mouseleave" placement="auto"></fa-icon>
        </span>
      </small>
      <div [hidden]="!organization || errorReadingOrganization">
        <a class="nav-link" [ngClass]="{'active': activeTab === 'HOME'}" href="{{ urlRoot + organization?.HomeLink }}" id="home-menu-item" tm-destination="/" i18n>
          <b *ngIf="organization?.OrganizationId !== CWK_ORGANIZATION_ID">
            <fa-icon class="me-2" [icon]="faMapMarkerAlt"></fa-icon>{{ organization?.Name }}
          </b>
          <span *ngIf="organization?.OrganizationId === CWK_ORGANIZATION_ID">Home</span>
        </a>
      </div>
    </li>

    <!-- RANKINGS -->
    <li class="nav-item">
      <a class="nav-link" [ngClass]="{'active': activeTab === 'RANKING'}" href="{{ urlRoot + '/ranking' }}" id="ranking" tm-destination="/ranking" i18n>Rankings</a>
    </li>

    <!-- SCHEDULE -->
    <li class="nav-item">
      <a class="nav-link" [ngClass]="{'active': activeTab === 'SCHEDULE'}" href="{{ urlRoot + '/schedule' }}" id="schedule" tm-destination="/schedule" i18n>Contests</a>
    </li>

    <!-- TRY A CHALLENGE -->
    <li class="nav-item">
      <a class="nav-link" [ngClass]="{'active': activeTab === 'TRIAL'}" href="{{ urlRoot + '/trial' }}" id="trial" tm-destination="/trial" i18n>Try a Challenge</a>
    </li>

    <!-- CONTEST -->
    <!--li class="nav-item">
      <a class="nav-link" [ngClass]="{'active': activeTab === 'CONTEST'}" href="{{ urlRoot + '/contest' }}" id="contest" tm-destination="/contest" i18n>Contest</a>
    </li-->

    <!-- RESOURCES -->
    <!--li class="nav-item">
      <a class="nav-link" [ngClass]="{'active': activeTab === 'RESOURCES'}" href="{{ urlRoot + '/resources' }}" id="resources" tm-destination="/resources" i18n>Resources</a>
    </li-->

    <!-- ACCOUNT (ACCESSIBLE ONLY TO SIGNED-IN USERS) -->
    <li class="nav-item" *ngIf="isSignedIn()">
      <a class="nav-link" [ngClass]="{'active': activeTab === 'ACCOUNT'}" href="{{ urlRoot + '/account' }}" i18n>Account</a>
    </li>

    <!-- STUDENT PROFILE (ACCESSIBLE ONLY TO SIGNED-IN STUDENTS) -->
    <li class="nav-item" *ngIf="isSignedInStudent()">
      <a class="nav-link" [ngClass]="{'active': activeTab === 'PROFILE'}" href="{{ urlRoot + '/profile' }}" i18n>Profile</a>
    </li>

    <!-- CURRENCY SELECTOR -->
    <!--cwk-currency-selector></cwk-currency-selector-->
  </ul>

  <small class="ms-5"><cwk-sign-in-out></cwk-sign-in-out></small>
</div>

<!-- MOBILE MENU -->
<div class="d-block d-md-none">
  <div class="d-flex align-items-center justify-content-end header-menu-mobile pt-1">

    <div class="cwk-white me-4">
      <cwk-sign-in-out *ngIf="!isSignedIn()"></cwk-sign-in-out>
      <span *ngIf="isSignedIn()" class="cwk-pointer">
        <span *ngIf="!isInternal()" (click)="goUrl('/account')">My Account</span>
        <span class="ms-3" (click)="signOut()">Logout</span>
      </span>
    </div>

    <!-- Currency selector -->
    <!--cwk-currency-selector class="me-4 pt-1" mode="MOBILE"></cwk-currency-selector-->

    <ul ngbNav>

      <!-- MOBILE MENU -->
      <li ngbDropdown ngbNavItem>
        <span class="cwk-white" ngbDropdownToggle role="button" aria-haspopup="true" aria-expanded="false" i18n>

          <!-- MENU BARS -->
          <fa-icon class="fs-1" (click)="switchMobileMenu()" [icon]="faBars"></fa-icon>
        </span>
        <div class="mobile-dropdown-menu" ngbDropdownMenu>

          <a href="{{ urlRoot + '/ranking' }}" id="ranking" tm-destination="/ranking" class="menu-link-section-item menu-link-open" i18n ngbDropdownItem>Rankings</a>
          <a href="{{ urlRoot + '/schedule' }}" id="schedule" tm-destination="/schedule" class="menu-link-section-item menu-link-open" i18n>Contests</a>
          <a href="{{ urlRoot + '/trial' }}" id="trial" tm-destination="/trial" class="menu-link-section-item menu-link-open" i18n>Try a Challenge</a>
          <!--a href="{{ urlRoot + '/contest' }}" id="contest" tm-destination="/contest" class="menu-link-section-item menu-link-open" i18n>Contest</a>
          <a href="{{ urlRoot + '/resources' }}" id="resources" tm-destination="/resources" class="menu-link-section-item menu-link-open" i18n>Resources</a-->

          <!-- ACCOUNT (ACCESSIBLE ONLY TO SIGNED-IN USERS) -->
          <li class="nav-item" *ngIf="isSignedIn()">
            <a href="{{ urlRoot + '/account' }}" id="account" tm-destination="/account" class="menu-link-section-item menu-link-open" i18n>Account</a>
          </li>

          <!-- STUDENT PROFILE (ACCESSIBLE ONLY TO SIGNED-IN STUDENTS) -->
          <li class="nav-item" *ngIf="isSignedInStudent()">
            <a href="{{ urlRoot + '/profile' }}" id="profile" tm-destination="/profile" class="menu-link-section-item menu-link-open" i18n>Profile</a>
          </li>
        </div>
      </li>

    </ul>
  </div>
</div>
